module.exports = __webpack_public_path__ + "static/media/OTK_header3.3596e577.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/OTK_header3.png
// module id = 295
// module chunks = 0